import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { DataService } from '../../services/data.service';

/**
 * Prescreen999Guard — shows the 999 pre-screening before the symptom checker.
 * Runs before /questionnaire activates, so the questions never flash on screen
 * first. Redirects to /prescreening when the pathway's questionnaire has it
 * switched on, parking the questionnaire content and the DTRS return state so
 * continueAfterPrescreen can hand both back. Returns true on the way back.
 */
export const prescreen999Guard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const data = inject(DataService);
  const router = inject(Router);

  if (data.consumePrescreenReturn()) {
    return true;
  }

  const content = await data.symptomCheckerPrescreen999();

  if (!content) {
    return true;
  }

  const state = router.getCurrentNavigation()?.extras?.state;

  data.prescreenQuestionnaire = content;
  data.prescreenProductZone = 'Symptom checker';
  data.prescreenNextUrl = '/questionnaire';
  data.prescreenNextState = {
    returnUrl: state?.['returnUrl'] ?? '',
    event: state?.['event'] ?? ''
  };

  return router.createUrlTree(['/prescreening']);
};
